/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INITSTATE = {
    suggestions: [],
    inventory_suggestions: [],
    content_suggestions: [],
};

export default function searchSuggestions(state = INITSTATE, action) {
    let st = state;

    switch (action.type) {
        case types.GET_SEARCH_SUGGESTIONS:
            st = { ...state };
            st.suggestions = action.suggestions;
            st.inventory_suggestions = action.inventory_suggestions;
            st.content_suggestions = action.content_suggestions;
            delete st.err;
            return st;

        case types.GET_SEARCH_SUGGESTIONS_ERROR:
            st = { ...state };
            st.err = action.err;
            return st;

        default:
            return st;
    }
}
